import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import Skeleton from '@mui/material/Skeleton';

interface ISkeleton {
  direction: 'column' | 'row';
  itemsCount: number;
  height: number;
  width: number | string;
}

export const LessonListSkeleton = (props: ISkeleton) => {
  const { direction, itemsCount, height, width } = props;
  const skeleton = [];
  for (let i = 0; i < itemsCount; i++) {
    skeleton.push(
      <Grid key={i}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={width}
          height={height}
        />
      </Grid>
    );
  }

  return (
    <Grid container direction={direction} spacing={1}>
      {skeleton}
    </Grid>
  );
};
